import { pslClient } from "@/common/http-common";
import { dereference } from "@/common/transforms";
import { downloadDocument } from "@/common/utils";
import {
  API_URL_GET_QUOTE_DOCUMENTS_LIST,
  API_URL_GET_STATIC_DOCUMENTS_LIST,
} from "@/constants/api.constants.js";

export class Document {
  getDocument(link, config) {
    const derefedConfig = dereference(config);
    derefedConfig.responseType = "blob";
    return pslClient.get(link, derefedConfig).then((res) => {
      return res.data;
    });
  }
  getDocumentList(quoteRequestId, callChannel, config) {
    const docListUrl = callChannel
      ? `${API_URL_GET_QUOTE_DOCUMENTS_LIST}/${quoteRequestId}?callChannelType=${callChannel}`
      : `${API_URL_GET_QUOTE_DOCUMENTS_LIST}/${quoteRequestId}`;

    return pslClient.get(docListUrl, config).then((res) => {
      return res.data;
    });
  }
  getQuoteDocuments(quoteId, callChannel, config) {
    const docListUrl = callChannel
      ? `${API_URL_GET_QUOTE_DOCUMENTS_LIST}/?quoteId=${quoteId}&callChannelType=${callChannel}`
      : `${API_URL_GET_QUOTE_DOCUMENTS_LIST}/?quoteId=${quoteId}`;

    return pslClient.get(docListUrl, config).then((res) => {
      return res.data;
    });
  }
  async downloadFile(fileName, httpConfig) {
    const quoteAndBuyApiUrl = process.env.VUE_APP_PSL_API_URL;
    const baseDirectory = "Content";
    const filePath = `${quoteAndBuyApiUrl}/${baseDirectory}/${fileName}`;
    const doc = await this.getDocument(filePath, httpConfig);
    downloadDocument(doc, fileName);
  }
  getAllDocuments(files, config) {
    const derefedConfig = dereference(config);
    derefedConfig.responseType = "blob";
    const allDocsUrl = `${API_URL_GET_QUOTE_DOCUMENTS_LIST}/AllDocuments`;
    return pslClient.post(allDocsUrl, files, derefedConfig).then((res) => {
      return res.data;
    });
  }
  getStaticDocuments(productId) {
    const staticDocUrl = `${API_URL_GET_STATIC_DOCUMENTS_LIST}/${productId}`;
    return pslClient.get(staticDocUrl).then((res) => {
      return res.data;
    });
  }
}

export default new Document();
